import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import { Container } from "react-bootstrap";
import Joyride, { STATUS } from "react-joyride";
// import
import TrustGridLogo from "../assets/images/trustgrid-ncc-logo-center.svg";
import GreterThen from "../assets/images/greterthen.svg";
import LessThen from "../assets/images/lessthen.svg";
import CollapseLogo from "../assets/images/collapse-trustgrid.svg";
import Icon from "../assets/images/why-iam.svg";
import "../assets/sass/app.scss";

const NetworkRoot = () => {
  const [start, setStart] = useState(false);
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const sidebarRef = useRef(null);

  // click out side menu collapsed on mobile screen
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        window.innerWidth <= 768 &&
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target)
      ) {
        setCollapsed(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [sidebarRef]);

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  const steps = [
    // sidebar menu wizard
    {
      target: ".dashboard-wiz",
      content: (
        <div style={{ textAlign: "left" }}>
          <p>
            The dashboard offers a snapshot of the consortium, displaying the
            count of onboarded issuers, verifiers, and created services.
          </p>
          <p>
            Additionally, it features graphical representations of verified
            identities, issued credentials, and the types of credentials issued.
          </p>
        </div>
      ),
      placement: "right",
      disableBeacon: true,
    },
    {
      target: ".issuer-wiz",
      content: (
        <div style={{ textAlign: "left" }}>
          <p>Browse the list of onboarded issuers or register a new one.</p>
        </div>
      ),
      placement: "right",
      disableBeacon: true,
    },
    {
      target: ".verifier-wiz",
      content: (
        <div style={{ textAlign: "left" }}>
          <p>Browse the list of onboarded verifiers or register a new one.</p>
        </div>
      ),
      placement: "right",
      disableBeacon: true,
    },
    {
      target: ".news-feed-wiz",
      content: (
        <div style={{ textAlign: "left" }}>
          <p>Stay updated with the latest news and upcoming updates.</p>
        </div>
      ),
      placement: "right",
      disableBeacon: true,
    },
    // dashboard page
    {
      target: ".all-issuer-card-wiz",
      content: (
        <div style={{ textAlign: "left" }}>
          <p>Number of issuers onboarded on the consortium.</p>
        </div>
      ),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: ".all-verifier-card-wiz",
      content: (
        <div style={{ textAlign: "left" }}>
          <p>Number of verifiers onboarded on the consortium.</p>
        </div>
      ),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: ".all-services-card-wiz",
      content: (
        <div style={{ textAlign: "left" }}>
          <p>Number of services created within the consortium.</p>
        </div>
      ),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: ".issued-credential-wiz",
      content: (
        <div style={{ textAlign: "left" }}>
          <p>Number of credentials issued monthly.</p>
        </div>
      ),
      placement: "right",
      disableBeacon: true,
    },

    {
      target: ".verified-identity-wiz",
      content: (
        <div style={{ textAlign: "left" }}>
          <p>Number of identities verified monthly.</p>
        </div>
      ),
      placement: "left",
      disableBeacon: true,
    },
    {
      target: ".credential-type-wiz",
      content: (
        <div style={{ textAlign: "left" }}>
          <p>
            The graph illustrates the status of credentials issued, such as
            Offer-sent, Done, etc
          </p>
        </div>
      ),
      placement: "left",
      disableBeacon: true,
    },
    {
      target: ".blockchain-ledger-wiz",
      content: (
        <div style={{ textAlign: "left" }}>
          <p>View the blockchain ledgers transaction records.</p>
        </div>
      ),
      placement: "top",
      disableBeacon: true,
    },
    // Issuer Page
    {
      target: ".issuer-search-wiz",
      content: (
        <div style={{ textAlign: "left" }}>
          <p>
            Type the name of the issuer organization to view its corresponding
            details.
          </p>
        </div>
      ),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: ".add-issuer-wiz",
      content: (
        <div style={{ textAlign: "left" }}>
          <p>Click here to onboard new issuers to the Consortium.</p>
        </div>
      ),
      placement: "bottom",
      disableBeacon: true,
    },
    // Verifier Page
    {
      target: ".verifier-search-wiz",
      content: (
        <div style={{ textAlign: "left" }}>
          <p>
            Type the name of the verifier organization to view its corresponding
            details.
          </p>
        </div>
      ),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: ".add-verifier-wiz",
      content: (
        <div style={{ textAlign: "left" }}>
          <p>Click here to onboard new verifiers to the Consortium.</p>
        </div>
      ),
      placement: "bottom",
      disableBeacon: true,
    },
    // logout popup
    {
      target: ".welcome-user",
      content: "Click here to access the logout option.",
      disableBeacon: true,
    },
  ];

  // Joyride Custom Style
  const joyrideStyles = {
    options: {
      zIndex: 10000,
      arrowColor: "#fff",
      backgroundColor: "#fff",
      primaryColor: "#4398CD",
      textColor: "#000",
      width: 400,
      height: 200,
    },
    tooltip: {
      fontSize: "16px",
    },
    buttonNext: {
      backgroundColor: "#4398CD",
      color: "#fff",
    },
    buttonBack: {
      color: "#000",
    },
    buttonSkip: {
      color: "#666",
    },
  };

  const handleJoyrideCallback = (data) => {
    const { status, action } = data;
    const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

    if (finishedStatuses.includes(status) || action === "close") {
      setStart(false);
      document.body.style.overflow = "auto";
    } else {
      document.body.style.overflow = "hidden";
    }
  };

  // Define a mapping of routes to steps that should be excluded
  const routeExclusions = {
    "/dashboard": [".dashboard-wiz"],
    "/issuers": [".issuer-wiz"],
    "/verifiers": [".verifier-wiz"],
    "/news-feed": [".news-feed-wiz"],
  };

  // Get the current route exclusions, default to an empty array
  const exclusions = routeExclusions[location.pathname] || [];

  // Filter the steps based on the current route exclusions
  const filteredSteps = steps.filter(
    (step) => !exclusions.includes(step.target)
  );

  return (
    <Container fluid className="main-layout  p-0">
      <Joyride
        steps={filteredSteps}
        run={start}
        continuous={true}
        scrollToFirstStep={true}
        showSkipButton={true}
        styles={joyrideStyles}
        callback={handleJoyrideCallback}
        showProgress={false}
        locale={{
          last: "Finish",
        }}
      />
      <nav
        ref={sidebarRef}
        className={`sidebar-menu ${collapsed ? "collapsed-menu" : ""}`}
      >
        <button onClick={toggleSidebar} className="toggle-button">
          {collapsed ? (
            <img src={GreterThen} alt="logo" />
          ) : (
            <img src={LessThen} alt="logo" />
          )}
        </button>
        <div className="d-flex flex-column flex-shrink-0">
          <Link to="/">
            {collapsed ? (
              <div className="collapse-brand-logo">
                <img
                  src={CollapseLogo}
                  alt="logo"
                  width={48}
                  height={48}
                  className="img-fluid"
                />
              </div>
            ) : (
              <div className="brand-logo">
                <img src={TrustGridLogo} alt="logo" className="img-fluid" />
              </div>
            )}
          </Link>
          <ul className="nav nav-pills flex-column mb-auto nav-menu">
            <li className="nav-item">
              <NavLink to="/dashboard" className="dashboard">
                {!collapsed ? (
                  <span className="dashboard-wiz">Dashboard</span>
                ) : (
                  ""
                )}
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/issuers" className="issuer">
                {!collapsed ? <span className="issuer-wiz">Issuers</span> : ""}
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/verifiers" className="verifier">
                {!collapsed ? (
                  <span className="verifier-wiz">Verifiers</span>
                ) : (
                  ""
                )}
              </NavLink>
            </li>
            {/* <li className="nav-item">
                <NavLink to="" className="blockchain-ledger">
                  <span className="blockchain-ledger-wiz">
                    Blockchain Ledger
                  </span>
                </NavLink>
              </li> */}
            <li className="nav-item">
              <NavLink to="/news-feed" className="news-feed">
                {!collapsed ? (
                  <span className="news-feed-wiz">News Feed</span>
                ) : (
                  ""
                )}
              </NavLink>
            </li>
          </ul>
        </div>
      </nav>
      <Outlet />
      <button className="wizard-btn" onClick={() => setStart(true)}>
        <img src={Icon} alt="icon" />
        Need Help?
      </button>
    </Container>
  );
};

export default NetworkRoot;
